// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-btn-upload-file .input-file-label {
  visibility: hidden;
  position: absolute;
  overflow: hidden;
  width: 0;
  height: 0;
  border: none;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-insert-media/btn-upload-file/btn-upload-file.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAAR","sourcesContent":["fi-btn-upload-file {\r\n    .input-file-label {\r\n        visibility: hidden;\r\n        position: absolute;\r\n        overflow: hidden;\r\n        width: 0;\r\n        height: 0;\r\n        border: none;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
